// La liste des adresses de projets d'un membre, telle que le back la garde.
//
// Deux pièges, tous deux côté back, que cette fonction absorbe pour l'affichage :
// - après un retrait, la liste a pu être enregistrée avec des trous dans sa numérotation. Elle
//   revient alors sous forme d'objet ({ "1": "…" }) et non de tableau : sans cette lecture, le
//   profil croyait que tous les projets avaient disparu ;
// - les adresses sont gardées avec leurs « & » écrits « &amp; ».
export function projectList(value) {
    const list = Array.isArray(value) ? value : value && typeof value === "object" ? Object.values(value) : [];
    return list.filter((url) => typeof url === "string" && url !== "").map((url) => url.replace(/&amp;/g, "&"));
}
